export default {
  'warehouse.tab.basic': 'Basic',
  'warehouse.field.file_no': 'File No.',
  'warehouse.field.post_date': 'Post Date',
  'warehouse.field.in_date': 'In Date',
  'warehouse.field.out_date': 'Out Date',
  'warehouse.field.order_no': 'Order No.',
  'warehouse.field.order_date': 'Order Date',
  'warehouse.field.container_no': 'Container No.',
  'warehouse.field.truck_bl_no': 'Truck B/L No.',
  'warehouse.field.expect_date': 'Expect Date',
  'warehouse.field.expiration_date': 'Expiration Date',
  'warehouse.field.warehouse_status': 'Status',
  'warehouse.field.pallet': 'Pallet',
  'warehouse.field.pallet_remark': 'Pallet Remark',
  'warehouse.field.remark': 'Remark',
  'warehouse.field.bill_to': 'Bill To',
  'warehouse.field.ship_from': 'Ship From',
  'warehouse.field.ship_to': 'Ship To',
  'warehouse.field.trucker': 'Trucker',
  'warehouse.field.bl_no': 'B/L No.',
  'warehouse.line.sku_no': 'SKU No.',
  'warehouse.line.customer_po': 'Customer P.O.',
  'warehouse.line.product_description': 'Product Description',
  'warehouse.line.order_po_no': 'Order P.O. No.',
  'warehouse.line.order_qty': 'Order Qty',
  'warehouse.line.qty': 'Qty',
  'warehouse.line.qty_unit': 'Qty Unit',
  'warehouse.line.pcs': 'PCS',
  'warehouse.line.pack': 'Pack',
  'warehouse.line.pack_unit': 'Pack Unit',
  'warehouse.line.pack_2': 'Pack 2',
  'warehouse.line.pack_2_unit': 'Pack 2 Unit',
  'warehouse.line.pallet': 'Pallet',
  'warehouse.line.weight': 'Weight',
  'warehouse.line.measurement': 'Measurement',
  'warehouse.line.shipping_qty': 'Shipping QTY',
  'warehouse.line.allocated_qty': 'Allocated Qty',
  'warehouse.line.items': 'Items',
  'warehouse.line.add': 'Add Line',
  'warehouse.status.pre_receiving': 'Pre-Receiving',
  'warehouse.status.received': 'Received',
  'warehouse.status.pre_shipping': 'Pre-Shipping',
  'warehouse.status.shipped': 'Shipped',
};
